import React from 'react';

import Chip from '@mui/material/Chip';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import {
  matchStatus,
  matchFeedbackType,
  matchPriority,
  getFormatedDate,
} from '../../../utils/feedback';

import { DetailsContainer, StyledHeaderCell } from './styles';

export default function SuperAdminDetails({ feedback }) {
  let backgroundColor = '#D1D1D1';
  if (feedback.status === 'open') backgroundColor = '#FF9F09';
  if (feedback.status === 'answered') backgroundColor = '#29CC6A';

  return (
    <DetailsContainer>
      <Table size="small">
        <TableHead>
          <TableRow>
            <StyledHeaderCell>Status</StyledHeaderCell>
            <StyledHeaderCell>Tipo de feedback</StyledHeaderCell>
            <StyledHeaderCell>Prioridade</StyledHeaderCell>
            <StyledHeaderCell>Nome</StyledHeaderCell>
            <StyledHeaderCell>E-mail</StyledHeaderCell>
            <StyledHeaderCell>Celular</StyledHeaderCell>
            <StyledHeaderCell>Data de abertura</StyledHeaderCell>
            <StyledHeaderCell>Ultima vez atualizado</StyledHeaderCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>
              <Chip
                sx={{ backgroundColor }}
                label={matchStatus(feedback.status)}
              />
            </TableCell>
            <TableCell>{matchFeedbackType(feedback.feedback_type)}</TableCell>
            <TableCell>{matchPriority(feedback.priority)}</TableCell>
            <TableCell>{feedback.user.name}</TableCell>
            <TableCell>{feedback.user.email}</TableCell>
            <TableCell>{feedback.user.phone}</TableCell>
            <TableCell>{getFormatedDate(feedback.created_at)}</TableCell>
            <TableCell>{getFormatedDate(feedback.updated_at)}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </DetailsContainer>
  );
}
